import uuidv4 from 'uuid/v4';
import get from 'lodash/get';
import first from 'lodash/first';

import {INVALID_LOGIN_OPTION_CODE} from '../constants';

// returns ajs_anonymous_id cookie value
export const anonymousUserId = () => {
  const idCookie = document.cookie.match(new RegExp('ajs_anonymous_id=([^;]+)'));
  if (idCookie) {
    const uuid = decodeURI(idCookie[1]).replace(/"/g, '');
    return uuid;
  }

  const idLocalStorage = localStorage.getItem('ajs_anonymous_id');
  if (idLocalStorage) {
    return idLocalStorage;
  }

  const id = uuidv4();
  setCookie('ajs_anonymous_id', id, 730);
  localStorage.setItem('ajs_anonymous_id', id);
  return id;
};

export const setCookie = (cookieName, cookieValue, expireDays) => {
  let expires = '';
  if (expireDays) {
    const d = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    expires = `expires=${d.toUTCString()};`;
  }

  document.cookie = `${cookieName}=${cookieValue};${expires}path=/`;
};

export const getCookie = cookieName => {
  const b = document.cookie.match(`(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`);
  return b ? b.pop() : '';
};

export const hasInvalidDomainLoginOptionError = graphQLErrors =>
  get(first(graphQLErrors), 'extensions.code') === INVALID_LOGIN_OPTION_CODE;
